import { render, staticRenderFns } from "./AdminMsDashboard.vue?vue&type=template&id=09a3a146"
import script from "./AdminMsDashboard.vue?vue&type=script&lang=js"
export * from "./AdminMsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports